<template>
<div >
  <div class="row">
        <div class="flex xs12 sm12 lg9">
          <h1>{{ $t('gestaocurso.Datamaterias') }}</h1>
        </div>
        <div  class="flex xs12 sm12 lg3">
          <va-button class="text-right" @click="novo = true"   :color="BuNovo.color" :style="BuNovo"> Nuevo</va-button>
        </div>
  </div>

  <div v-if="novo">
           <form @submit.prevent="addNovo()">
              <div class="row">
                  <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="datamateria.oferta_disciplina_grade"
                      textBy="nome_disciplina"
                      :options="getAllMateriasCurso"
                      placeholder="Materia curso"
                    />  
                  </div>

                  <div class="flex md3 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="datamateria.funcionario_id"
                      textBy="nome_disciplina"
                      :options="getAllProfessor"
                      placeholder="Profesor"
                    />  
                  </div>
                  

                      <div class="flex md3 sm12 xs12">
                        <va-input
                        :label="$t('forms.selects.simple')"
                          v-model="datamateria.data_abertura"
                         type="date"
                          placeholder="Fecha Inicio"
                        />
                      </div>
                      <div class="flex md3 sm12 xs12">
                        <va-input
                        :label="$t('forms.selects.simple')"
                          v-model="datamateria.data_encerramento"
                          type="date"
                          placeholder="Fecha Encerramento"
                        />
                      </div>

                
                     <div class="flex md2 sm12 xs12 text-center">
                          <va-button type="submit" class="text-right"   color="dark"> {{ $t('arealuno.Inserir') }}</va-button>
                      </div>
                      
                
                </div>
               
              
          </form>

  </div>

  <div v-if="abrireditar">
           <form @submit.prevent="salvarEditarMateria()">
              <div class="row">
                 

                  <div class="flex md4 sm12 xs12">
                    <va-select
                      :label="$t('forms.selects.simple')"
                      v-model="funcionario_id"
                      textBy="nome"
                      :options="getAllProfessor"
                      placeholder="Profesor"
                    />  
                  </div>
                  

                      <!-- <div class="flex md3 sm12 xs12">
                        <va-input
                        :label="$t('forms.selects.simple')"
                          v-model="editar.data_abertura"
                         type="date"
                          placeholder="Fecha Inicio"
                        />
                      </div>
                      <div class="flex md3 sm12 xs12">
                        <va-input
                        :label="$t('forms.selects.simple')"
                          v-model="editar.data_encerramento"
                          type="date"
                          placeholder="Fecha Encerramento"
                        />
                      </div> -->

                
                     <div class="flex md2 sm12 xs12 text-center">
                          <va-button type="submit" class="text-right"   color="dark"> Salvar</va-button>
                      </div>
                      
                
                </div>
               
              
          </form>

  </div>
 
    <va-data-table
          :fields="fields"
          :data="getdados"
          hoverable
          no-pagination
          >
          
              <template slot="marker" slot-scope="props">
                <va-icon name="fa fa-circle" :color="props.rowData.color" size="8px" />
              </template>

              <template slot="actions" slot-scope="props">

                 <!-- <va-button flat small color="primary" @click="abrirProfessor(props.rowData)" class="ma-0">
                  Professor
                </va-button> -->

                  <va-button flat small color="primary" @click="abrir_avaliacoes(props.rowData)" class="ma-0">
                  Avaliacoes
                </va-button>

                 <va-button flat small color="success" @click="abrir_conteudos(props.rowData)" class="ma-0">
                  Contenidos
                </va-button>

                <va-button flat small color="warning" @click="abrirmaterias(props.rowData)" class="ma-0">
                  Alumnos
                </va-button>

                <va-button flat small color="info" @click="editarMateria(props.rowData)" class="ma-0">
                  {{ $t('tables.edit') }}
                </va-button>

              </template>
              
        </va-data-table>

</div>

      
 
</template>

<script>

export default {
  name: 'datamateria',
  

  data () {
      return {

        funcionario_id:'',

        editar:{
          funcionario_id:'',
          id:''
        },
        abrireditar:false,
       
       
        BuNovo: {
          color:'info',
          'width': '100%',
        }, 
        novo: false,

        datamateria:{
            oferta_disciplina_grade: '',
            oferta_grade_empresa: this.$store.state.gradecurricular.dados_gradecurricular,
            data_abertura: '',
            data_encerramento: '',
          },
       
      }
    },
    created(){
      
      this.all();
      this.materiaCurso();
  
  
    },
    computed: {

      getdados (){
          return this.$store.state.datamateria.datamateria   
      },
      getAllMateriasCurso(){
        return this.$store.state.datamateria.allmateriacurso   
      },
       getAllProfessor(){
        return   this.$store.state.funcionarios.getprofessores  
      },
  
      fields () {
          return [{
            name: '__slot:marker',
            width: '30px',
            dataClass: 'text-center',
          }, {
            name: 'nome_disciplina',
            title: this.$t('tables.headings.name'),
          }, {
            name: 'nome_funcionario',
            title: this.$t('tables.headings.name'),
          }, {
            name: 'nome',
            title: this.$t('tables.headings.name'),
          }, {
            name: 'data_abertura',
            title: this.$t('tables.headings.name'),
          },
          {
            name: 'data_encerramento',
            title: this.$t('tables.headings.name'),
          }, {
            name: '__slot:actions',
            dataClass: 'text-right',
          }]
      },
  },

  methods: {

     editarMateria (value) {
     this.abrireditar = true
     this.editar = value
     this.novo = false

    
      },
    async salvarEditarMateria () {
      
     this.abrireditar = false
     

     var dados = {
         id : this.editar.id,
         funcionario_id: this.funcionario_id.id

     }

     this.editar = {}
     await this.$store.dispatch('salvarEditarMateria',dados);
     
      this.all()
      },

    abrirProfessor (value) { // esta em desuso
     console.log(value)
      this.$store.dispatch('setGradeCurricular',value);
      this.$emit('trocar_component', 'addprofessor');
     
      
      },

    abrir_conteudos (value) {
     
       this.$store.dispatch('setMateria',value);
       this.$router.push( {name: 'professor' })
      
      
    },
    abrir_avaliacoes(value){

       this.$store.dispatch('setMateria',value);
       this.$emit('trocar_component', 'addavaliacao');


    },

    all (){
      this.$store.dispatch('allDatamateria',this.$store.state.gradecurricular.dados_gradecurricular.id)
     this.$store.dispatch('allProfessores')
    },
     materiaCurso (){
      
      this.$store.dispatch('allMateriaCurso',this.$store.state.gradecurricular.dados_gradecurricular.grade_curricular_id)
    },
    addNovo () {
      
      this.datamateria.oferta_grade_empresa =this.$store.state.gradecurricular.dados_gradecurricular
      this.$store.dispatch('addDatamateria',this.datamateria)

      this.datamateria = {
        oferta_disciplina_grade: '',
        data_abertura: '',
        data_encerramento: '',
        nome: '',
        
          },
       this.all()
    },
    

    
  },
}
</script>

<style lang="scss">

</style>
